import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SpecialtiesProvidersPoisComponent } from './pages/specialties-providers-pois/specialties-providers-pois.component';
import { tenantRouteGuard } from 'src/app/tenant-config/tenant-route.guard';

const routes: Routes = [
    {
        path: 'buscar-prestadores',
        component: SpecialtiesProvidersPoisComponent,
        canActivate: [tenantRouteGuard],
        data: {
            breadcrumb: 'Buscar Prestadores',
            tenantRoute: '/app/prestadores/buscar-prestadores',
        }
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ProvidersRoutingModule { }
